<div [ngStyle]="getWidth()">
    <span style="margin-right: 10px" class="normal-text">{{ label }}</span>
    <span style="float: right">
        <dx-switch
            #ccSwitch
            [disabled]="isDisabled"
            [value]="switchValue"
            (valueChange)="switchValueChange.emit($event)"
            [width]="50"
            [switchedOnText]="useYesNoText ? 'Yes' : 'On'"
            [switchedOffText]="useYesNoText ? 'No' : 'Off'"
        ></dx-switch>
    </span>
</div>
